export default __webpack_public_path__ + "static/media/closeDeleteIcon.7c13a624.svg";